module.exports = __webpack_public_path__ + "static/img/04.f91af95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/k_mueller/04.jpg
// module id = 411
// module chunks = 1